import Navigation from '../components/Navigation';
import Header from '../components/Header';
import Services from '../components/Services';
import Contact from '../components/Contact';
import '../components/styles.css'
import { useEffect } from 'react';
import useTitle from "@nooks/use-title";

const headerContent = {
    heading: "carryvilly",
    subheading: "캐리어? 빌리세요!",
    linkBtn: true,
    reviewBtn: true
}

function Home({userObj, isLoggedIn}){
    useTitle("캐리어 필요할때! 캐리빌리")
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <Header content={headerContent}/>
            <Services />
            <Contact />
        </div>
    )
}

export default Home;